import * as React from 'react';

import { ActivityIndicator } from '@mam/main/UI';
import ERPCreateNewScenarioButton from './ERPCreateNewScenarioButton';
import ERPInterventionsEmptyState from './ERPInterventionsEmptyState';
import ERPInterventionScenario from './ERPInterventionScenario';

import type { ERPRequestApiResult } from './api/ERPSessionRequest';

interface ERPInterventionsProps {
	currency: string;
	erpSessionResult: ERPRequestApiResult;
	virtualProductPackName: string;
	userId: string;
	onNewScenarioCreate?: () => void;
	onScenarioEdit: (name: string) => void;
}

const ERPInterventions = ({
	currency,
	erpSessionResult,
	virtualProductPackName,
	userId,
	onNewScenarioCreate,
	onScenarioEdit,
}: ERPInterventionsProps) => {
	const erpSessionDetail = erpSessionResult.value?.erpSessionDetail;
	if (!erpSessionDetail || erpSessionResult.isLoading) {
		return <ActivityIndicator />;
	}

	return (
		<div className='px-10 bg-white border-b-2 border-gray-300'>
			<div className='pt-10 pb-12 w-full max-w-7xl mx-auto text-center'>
				<div className='pb-2 flex justify-between items-center'>
					<h2 className='font-display text-h2-head font-semibold text-cPurple-600'>Intervention Scenarios</h2>
					<ERPCreateNewScenarioButton onNewScenarioCreate={onNewScenarioCreate} />
				</div>
				{(erpSessionDetail.erpSession.scenarios || []).length > 0 ? (
					erpSessionDetail.erpSession.scenarios.map((scenario, index) => (
						<ERPInterventionScenario
							currency={currency}
							erpPackId={erpSessionDetail.erpPack.id}
							erpSessionId={erpSessionDetail.erpSession.id}
							index={index + 1}
							key={scenario.id}
							scenario={scenario}
							userId={userId}
							virtualProductPackName={virtualProductPackName}
							onScenarioEdit={onScenarioEdit}
						/>
					))
				) : (
					<ERPInterventionsEmptyState />
				)}
			</div>
		</div>
	);
};

export default React.memo(ERPInterventions);
